import React from 'react';
import { withRouter } from 'react-router-dom';

import MenuIcon from '@material-ui/icons/Menu';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import SIDEMENU from '../../data/menu/sidemenu.data';

import Sidebar from 'react-sidebar';
import CourseContent from './CoursePTContent/CoursePTContent';

import api from '../../services/api';

import './CoursePT.scss';

const mql = window.matchMedia(`(min-width: 800px)`);

class CourseSideMenu extends React.Component{
  constructor() {
    super();

    this.state = {
      menu: SIDEMENU,
      docked: mql.matches,
      open: false
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.onSetOpen = this.onSetOpen.bind(this);
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  componentDidMount() {
    this.getLevelCourse();
  }

  onSetOpen(open) {
    this.setState({ open });
  }

  mediaQueryChanged() {
    this.setState({
      docked: mql.matches,
      open: false
    });
  }

  toggleOpen(event) {
    event.preventDefault();
    this.setState({ open: !this.state.open });
  }

  formatDate( date ) {
    const formDate = new Date(date);
    const day = formDate.getDate();
    const year = formDate.getFullYear();
    const month = formDate.getMonth() + 1;

    return day + '/' + month + '/' + year;
  }

  isDeadline(deadline) {
    const formDate = new Date(deadline);
    const today = new Date();

    return this.formatDate(formDate) === this.formatDate(today);
  }

  getLevelCourse = async () => {
    const userId = localStorage.getItem('userId');
    const response = await api.get(`/user/${userId}`);
    const courseId = localStorage.getItem('courseId');

    if (response.data.courses.length > 0) {
      const course = response.data.courses.find(({
        course_id
      }) => course_id === courseId);

      if (!course) {
        return;
      }

      if (this.isDeadline(course.deadline)) {
        this.props.history.push('/dashboard');
      } else {
        const level = course.level;
        const module = course.module;
        this.setLevelCourse(level, module);
      }
    }
  }

  setLevelCourse = ( level, module ) => {
    localStorage.setItem('courseLevel', level);

    const menu = this.state.menu.map((item) => ({
      ...item,
      items: item?.items ? item.items.map((subitem) => ({ ...subitem })) : item?.items,
    }));

    menu.map((item, index) => {
      if( item?.id === level || item?.id < level ) {
        menu[index].enabled = true;
      }

      if( item?.id === level ) {
        menu[index].hidden = false;
      } else if (level > 7) {

        menu[0].hidden = false;
      } else {
        menu[index].hidden = true;
      }

      if ( item?.items ) {
          item.items.map((subitem, subindex) => {

            if (level > 7 ) {
              if (item?.id === 1 && subindex === 0) {
                subitem.hidden = false;
              } else {
                subitem.hidden = true;
              }
            } else {
              if (item?.id === level && (subindex + 1) === module) {
                subitem.hidden = false;
              } else {
                subitem.hidden = true;
              }
            }

            if (item?.id < level) {
              menu[index].watched = true;
              subitem.watched = true;
            } else if (item?.id === level) {
              if ((subindex + 1) < module && (subindex + 1) !== module) {
                subitem.watched = true;
              }
            }
        });
      }

    });

    this.setState({ menu });
  }

  handleMenu = menu => {
    return (
      <div className="sidemenu">
        {
          menu?.map((item, index) => (
            <div key={ item?.id }>
              <a
                href= {`#${item?.id}`}
                className={`menu-title ${item?.watched ? 'watched' : ''}`}
                onClick={ () => {
                  if ( item?.enabled ) {
                    const menu = this.state.menu.map((menuItem, menuIndex) => (
                      menuIndex === index
                        ? { ...menuItem, hidden: !menuItem.hidden }
                        : menuItem
                    ));

                    this.setState({ menu });
                  }
                }}
              >
                { item?.title }
                <ExpandMoreIcon className="float-r" />
              </a>

              {
                item?.items.map((submenu, i) =>
                  <a
                    key={i}
                    href= {`#${this.state.menu[index].items[i].link}`}
                    className={`
                      menu-item
                      ${item?.hidden ? 'hide' : ''}
                      ${submenu?.watched ? 'watched' : ''}
                    `}
                    onClick={ () => {
                      const menu = this.state.menu.map((menuItem, menuIndex) => ({
                        ...menuItem,
                        items: menuItem.items.map((menuSubitem, subIndex) => ({
                          ...menuSubitem,
                          hidden: !(menuIndex === index && subIndex === i),
                        })),
                      }));

                      this.setState({ menu });
                    }}
                  >
                    { submenu.title }
                  </a>
                )
              }
            </div>          
          ))
        }
      </div>
    );
  }

  render(){
    const { menu, open, docked } = this.state;

    return (
      <div className="container">
        <Sidebar
          sidebar={this.handleMenu(menu)}
          open={open}
          onSetOpen={this.onSetOpen}
          docked={docked}
          styles={{ sidebar: { background: "white" } }}
        >
          <div className="header-course">
              {
                  !docked && (
                      <a
                        className="toggle-menu"
                        onClick={this.toggleOpen}
                        href="#dock"
                      >
                        <MenuIcon />
                      </a>
                  )
              }
              <h2>Head Start Courses |</h2>
              <h4> Food Safety - HACCP(Level 1)</h4>
          </div> 
          <CourseContent menu={menu} />
        </Sidebar>
      </div>
    );
  }
}

export default withRouter(CourseSideMenu);